import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
export const LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAME = Object.freeze({
  [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_BY_USER_ID]: 'hs_updated_by_id',
  [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: 'hs_created_by_id',
  [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_AT]: 'hs_createdate',
  [CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID]: 'hs_content_group_id'
});
export const LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAMES_TO_CMP_PROPERTY_NAMES = Object.freeze({
  hs_updated_by_id: CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_BY_USER_ID,
  hs_created_by_id: CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID,
  hs_createdate: CONTENT_PLATFORM_PROPERTY_NAME.CREATED_AT,
  hs_content_group_id: CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID
});
export const STANDARD_PROPERTY_DEFINITION_TYPES = {
  [CONTENT_PLATFORM_PROPERTY_NAME.AUDIENCE_ACCESS]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.CAMPAIGN]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_BY_USER_ID]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.CREATED_AT]: 'datetime',
  [CONTENT_PLATFORM_PROPERTY_NAME.DOMAIN]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE]: 'datetime',
  [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT]: 'datetime',
  [CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_BY_USER_ID]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.NAME]: 'string',
  [CONTENT_PLATFORM_PROPERTY_NAME.STATE]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.TEAM_PERMS]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.APPROVAL_PUBLISH_STATUS]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE]: 'enumeration',
  [CONTENT_PLATFORM_PROPERTY_NAME.GROUP_ID]: 'enumeration'
};